import React, { Fragment } from "react";
import Footer from "../../components/Footer_/Footer";
import BlogSec from "../../components/BlogSec_/BlogSec";
import Reviews from "../../components/Reviews_/Reviews";
import CategoriesRow from "../../components/CategoriesRow_/CategoriesRow";
import Hero from "../../components/Hero/Hero";
import AboutSec from "../../components/AboutSec_/AboutSec";
import Services from "../../components/Services_/Services";
import CallToAction from "../../components/CallToAction/CallToAction";
import { Helmet } from "react-helmet";
import ContactForm from "../InfoScreens/ContactForm";

const HomeScreen = () => {
  return (
    <Fragment>
      <Helmet>
        <title>
          TRU Off Grid | Solar, Battery Backup & Off-Grid Systems in Milton, ON
        </title>
        <link rel="canonical" href="https://truoffgrid.com/" />
        <meta
          name="description"
          content="Solar and battery storage installers in Milton, Ontario. EG4, EP Cube 2.0 and EcoFlow systems for homes, cottages, off-grid properties and job sites, with a licensed master electrician on staff."
        />
      </Helmet>
      <h1 style={{display:"none"}}>Solar, Battery and Off-Grid Systems in Milton, Ontario</h1>
      <Hero />
      <CategoriesRow paddingBottom={"0px"} />
      <Services />
      <ContactForm />
      <AboutSec
        heading={"ABOUT TRU OFF GRID"}
        subHeading={"Who We Are"}
        text={`We are a family business located in Milton, Ontario focused on lithium battery technology, home back up and solar energy solutions. We are relentless about offering our customers the best value for their dollar and providing the best solution for a use case. We partner only with reputable brands and companies who manufacture products that are rigorously tested and certified for performance and safety and offer the best warranty programs.
           <br/><br/> Please reach out to Jack Abrams, Owner and Co-Founder of TRU Off Grid at <a href="tel:+19054626525">905 462 6525</a> or <a href="mailto:sales@truoffgrid.com">sales@truoffgrid.com</a>
        `}
        buttonLink={"/about"}
        buttonText={"About us"}
        img={"/images/about.webp"}
      />
      <AboutSec
        heading={"We are Powering Life Anywhere"}
        text={`We supply and install clean energy systems: EG4 and EP Cube 2.0 home batteries, solar panels and racking, EcoFlow portable power, Volthium lithium batteries and backup generators. Homes, cottages, off-grid properties, RVs, farms, businesses and job sites. Please call us at <a href="tel:9054626525">905 462 6525</a>`}
        buttonText={"Shop Now"}
        buttonLink={"/shop"}
        reverse={true}
        backgroundImage={true}
        img={"/images/video.jpeg"}
        imgLink={"https://www.youtube.com/shorts/SniSJxlrnMQ"}
      />
      <AboutSec
        heading={"SOLAR INSTALLATION & BATTERY, INVERTER SYSTEM INSTALLATION"}
        // text={`We are authorized installers for EcoFlow, EG4 and Canadian Solar EP Cube systems and are experienced Solar Installers for Grid Tie, Net Metre and Off Grid Solar Projects as well as Battery and Inverter systems for Home, Cottage and Commercial Power Back Up. We are fully insured, safety trained and partner with a master electrician for all home panel and circuit integraton projects. 
        //        <br/><br/>
        //        We have been successful at helping several customers with Solar Installation Grant and Loan Applications. 
        //        <br/><br/>
        //        Please contact Jack Abrams for Free Assessment and to discuss your project. `}
        text={`We are authorized installers for EG4, Canadian Solar EP Cube 2.0 and EcoFlow systems, and experienced solar installers for grid-tie net metering, load displacement and off-grid systems, as well as battery and inverter systems for home, cottage and commercial power backup. We are fully insured, safety trained, and our own licensed master electrician handles all home panel and circuit work.
<br/><br/>
We have been successful at helping several customers with solar installation, grant and rebate applications.
<br/><br/>
Please contact Jacob Collier for a free assessment and to discuss your project.
`}
        // buttonLink={"tel:+19052997841"}
        buttonLink={"tel:647 914 9699"}
        buttonText={"More Information"}
        // img={"/images/urt.jpg"}
        img={"/images/home-text-3-new.png"}
      />
      {/* <CategoriesSec />
      <MainCategoriesSec /> */}
      <CallToAction />
      <BlogSec />
      <Reviews />
      <Footer newsletter={true} />
    </Fragment>
  );
};

export default HomeScreen;
